import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { WEBAPP_ROUTE_PREFIX } from '../../../constants/route'
import { useInitData, useLinkLikeClick } from '../../../hooks'
import { getBuildingProfilePathname } from '../../../utils/link'
import { ListItem } from '../../ListItem'

import { isNeedToShowEntityProfileBuildingItemIcons } from './EntityProfileBuildingItem.utils'

import * as styles from './EntityProfileBuildingItem.module.css'

import BuildingIcon from '../../../icons/building.svg'

function EntityProfileBuildingItem({
  className = styles.EntityProfileBuildingItem,
  value,
  ...restProps
}) {
  const { handleClick } = useLinkLikeClick()

  const { availableSections } = useInitData()

  function handleClickBuilding() {
    const link = getBuildingProfilePathname({ availableSections, id: value })

    handleClick({
      link,
      // Webapp fallback keeps opening in a new tab; NG profile navigates in-app.
      outsideLink: link.includes(WEBAPP_ROUTE_PREFIX),
    })
  }

  return (
    <ListItem
      {...restProps}
      ListIcon={BuildingIcon}
      className={className}
      isNeedToShowIcons={isNeedToShowEntityProfileBuildingItemIcons}
      textClassName={styles.text}
      tooltipProps={{ placement: FLOATING_ELEMENT_PLACEMENT.top }}
      onClick={handleClickBuilding}
    />
  )
}

export default EntityProfileBuildingItem
